import React, { useContext, useEffect, useState, } from 'react'
import PropTypes from 'prop-types'
import {
    Col,
    Row,
    Select,
} from '../../common/UIComponents'
import { moveOrdersToNewFromPending } from '../../api/OrdersApi'
import I18n from '../../common/I18n'
import { RejectedReasonApi } from '../../api/RejectedReason'
import { OrgContext } from '../../context/OrgContext'
import { renderAlertMessage } from '../../helpers/common'
import Button_v2 from './Button_v2'
import { ArrowDownIcon, CloseIcon, TickIcon } from '../../common/CustomIcon'
import Modal_v2 from './Modal_v2'
import ReasonWindow from '../../components/common/ReasonWindow'
import { renderNotification } from '../../components/orders/OrderTypeIcons'

const ActionsForPendingOrders = ({
    orderIds,
    isDisabled = false,
    setIsLoading,
    handleStatusResult,
}) => {
    const [showInfoWindow, setShowInfoWindow] = useState(false)
    const [rejectionCode, setRejectionCode] = useState('NONE');
    const [rejectionReason, setRejectionReason] = useState(false)
    const [approvalRejections, setApprovalRejections] = useState([]);
    const orgContextData = useContext(OrgContext);
    const { currentOrg } = orgContextData;

    const resetValues = (closeModal = false) => {
        setShowInfoWindow(false)
        if (closeModal) {
            // handleCancel()
        }
    }

    useEffect(() => {
        getRejectionReason()
    }, [])

    const handleOptionChange = (value) => {
        setRejectionCode(value);
    };

    const getRejectionReason = () => {
        const organization_id = currentOrg.id;
        RejectedReasonApi.fetchRejectedReason(organization_id).then((result) => {
            if (result.success) {
                const rejectionMessages = result.rejection_messages || [];
                setApprovalRejections(rejectionMessages);
            } else {
                renderAlertMessage(result.errors)

            }
        });
    };


    const renderModalWindow = () => {
        return (
            <Modal_v2
                title={I18n.t('general.reason')}
                className="customer-orders-modal"
                onCancel={() => {
                    resetValues();
                }}
                width="30%"
                visible={showInfoWindow}
                footer={false}
                closable={false}
            >
                <Row type='flex' gutter={16} align='middle' style={{ marginBottom: '16px' }}>
                    <Col className='order-rejection-text'>{I18n.t("general.rejection_to_reason")}</Col>
                    <Col>
                        <Select onChange={handleOptionChange} value={rejectionCode} style={{ width: '200px' }} suffixIcon={<ArrowDownIcon />} className='order-rejection-dropdown'>
                            <Select.Option value="NONE">{I18n.t("general.none")}</Select.Option>
                            <Select.Option value="CUSTOM">{I18n.t("general.custom_message")}</Select.Option>
                            {approvalRejections.map((message) => (
                                <Select.Option key={message.id} value={message.rejection_code}>
                                    {message.rejection_message}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>

                {rejectionCode !== 'CUSTOM' ? (
                    <Row type='flex' justify='end' gutter={16}>
                        <Col>
                            <Button_v2
                                onClick={resetValues}
                                className="medium-btn flat"
                            >
                                {I18n.t("general.close")}
                            </Button_v2>
                        </Col>
                        <Col>
                            <Button_v2
                                onClick={() => handleStatusChange('REJECTED')}
                                className="medium-btn raised"
                            >
                                {I18n.t("general.save")}
                            </Button_v2>
                        </Col>
                    </Row>
                ) : rejectionCode === 'CUSTOM' ? (
                    <Row>
                        <Col span={24}>
                            <ReasonWindow
                                reasonElement={'rejection_reason'}
                                reasonValue={rejectionReason}
                                handleOnChange={(element, value) => {
                                    setRejectionReason(value)
                                }}
                                closeReasonModal={resetValues}
                                saveReason={() => handleStatusChange('REJECTED')}
                            />
                        </Col>
                    </Row>
                ) : null}
            </Modal_v2>
        );
    };

    const handleStatusChangeCalls = (func, status) => {
        try {
            func().then((result) => {
                handleStatusResult(result, orderIds)
                resetValues(status === 'REJECTED')
            })
        } catch (error) {
            renderNotification(error.message, "error")
        } finally {
            setIsLoading(false)
        }
    }

    const handleStatusChange = (status, reasonMessage = '') => {
        setIsLoading(true)
        if (status === 'APPROVED') {
            const data = {
                order_ids: orderIds,
                status: 'APPROVED',
                rejection_reason: 'Approved',
            }
            handleStatusChangeCalls(() => moveOrdersToNewFromPending(data), status)
        } else if (status === 'REJECTED') {
            const selectedReason = approvalRejections.
                filter(msg => msg.rejection_code === rejectionCode).
                map((message) => message.rejection_message).join(',')
            let data = {
                order_ids: orderIds,
                status: 'REJECTED',
                rejectionCode,
                rejection_reason: rejectionCode !== 'CUSTOM' ? selectedReason : (rejectionReason || '')
            }


            handleStatusChangeCalls(() => moveOrdersToNewFromPending(data), status);
        }
    }

    return (
        <>
            <Button_v2
                className="flat small-btn"
                text={
                    <span className='action-btn-text'>
                        <TickIcon height="16" width="16" color="#617AD6" />
                        <span>Accept</span>
                    </span>
                }
                onClick={() => handleStatusChange('APPROVED', 'Approved')}
                disabled={isDisabled}
            />
            <Button_v2
                className="flat small-btn"
                text={
                    <span className='action-btn-text'>
                        <CloseIcon height="16" width="16" color="#617AD6" />
                        <span>Reject</span>
                    </span>
                }
                onClick={() => setShowInfoWindow(true)}
                disabled={isDisabled}
            />
            {showInfoWindow && renderModalWindow()}
        </>
    )
}

ActionsForPendingOrders.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    orderIds: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ActionsForPendingOrders
